import { ApiClient } from '@/config/axios.config';
import type { ReportComment, ReportCommentFilter } from '@/types/dailyReports.types';

/**
 * Daily Reports API Service
 * Handles API calls for report comments
 */
export class DailyReportsService {
  private static readonly BASE_PATH = '/reports/comments';

  /**
   * Get report comments with filtering
   */
  static async getComments(filter: ReportCommentFilter): Promise<ReportComment[]> {
    const params = new URLSearchParams({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString(),
      ...(filter.dateOrder && { dateOrder: filter.dateOrder }),
    });

    return ApiClient.get<ReportComment[]>(`${this.BASE_PATH}?${params}`);
  }
}
